import AdditionalInfoTable from './AdditionalInfoTable';

export default AdditionalInfoTable;
